import React from "react";
import "./Banner.css";

function Banner() {
  return (
    <div className="banner">
      <div className="banner__img">
        <h1>SALEM ENGINEERING COLLEGE</h1>
        <h3>Developed by @<span> Arun Dhas</span></h3>
      </div>
    </div>
  );
}

export default Banner;
